<template>
    <pop-form v-if="state" width="600px">
        <div slot="title">
            修改等级名称
            <i class="el-icon-close fr" @click="$emit('stateChange', false)"></i>
        </div>
        <div class="cateBody">
            <div class="listBox">
                <div class="item" v-for="(val, key) in listData" :key="key">
                    <input type="text" v-model="val.vip_name" />
                </div>
            </div>
        </div>
        <div slot="foot" class="foot-box">
            <el-button size="medium" @click="cancelSave">&nbsp;&nbsp;取消&nbsp;&nbsp;</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
            <el-button size="medium" type="primary" @click="submitSave">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>
        </div>
    </pop-form>
</template>

<script>
    import PopForm from "@/model/PopForm";
    import obj from "@/js/obj";
    export default {
        name: "EditVipName",
        components: {PopForm},
        props: {
            state: {
                type: Boolean,
                default: true
            },
            listData: {
                type: Array,
                default: []
            }
        },
        model: {
            prop: "state",
            event: "stateChange"
        },
        mounted: function () {

        },
        methods: {
            submitSave: function () {
                let setData = [];
                this.listData.forEach((v,k) => {
                    setData.push({
                        vip_id: v.vip_id,
                        vip_name: v.vip_name
                    });
                });

                obj.postData("store_vip/set_many_vip_name", {setData: JSON.stringify(setData)}, res => {
                    if(res.errcode === 0) {
                        obj.message.success("修改完成");
                        this.$emit("stateChange", false);
                        this.$emit("done", this.listData);
                    }else
                        obj.message.error("修改失败");
                });
            },
            cancelSave: function () {
                this.$emit("stateChange", false);
            }
        }
    }
</script>

<style scoped>
    .listBox{
        height: 300px;
        overflow: auto;
    }
    .listBox>.item{
        width: 33.33%;
        float: left;
        text-align: center;
    }
    .item>input{
        width: 168px;
        height: 40px;
        margin-bottom: 10px;
        border-radius: 3px;
        border: solid 1px #dcdfe6;
        line-height: 40px;
        text-align: center;
    }
</style>
